module.exports = __webpack_public_path__ + "static/media/myprofilepic-c.1401181e.jpg";